export default __webpack_public_path__ + "static/rental-662980ded1bac67d30c82767ba7e461e.jpg";